import { render } from "./ModsView.vue?vue&type=template&id=140f291c&scoped=true"
import script from "./ModsView.vue?vue&type=script&lang=js"
export * from "./ModsView.vue?vue&type=script&lang=js"

import "./ModsView.vue?vue&type=style&index=0&id=140f291c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140f291c"]])

export default __exports__